import React from "react";
import {WrappedFieldProps} from "redux-form";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

import "./FormRadioGroup.scss";

interface IFormRadioProps {
  label: string,
  value: any,
  className: string
}

interface IFormRadioGroupProps extends WrappedFieldProps {
  label: string,
  className: string,
  radios: IFormRadioProps[]
}

/**
 * Reusable component for defining a list of form radio options
 *
 * @param input
 * @param label
 * @param className
 * @param radios
 * @constructor
 */
const FormRadioGroup = ({input, label, className, radios}: IFormRadioGroupProps) => {
  return (
    <div className={`nzpost-js-tools-form-radio-group-container ${className}`}>
      <FormControl component="fieldset">
        <FormLabel component="legend" className="nzpost-js-tools-form-radio-group-label">{label}</FormLabel>
        <RadioGroup aria-label={label} name="addressConfirmed" value={input.value} onChange={(event, value) => input.onChange(value)}
                    className="nzpost-js-tools-form-radio-group">
          {radios.map((radio, i) => <FormControlLabel key={i} value={radio.value}
                                                      control={<Radio color="primary" className={radio.className}/>}
                                                      label={radio.label}
                                                      className="nzpost-js-tools-form-radio"/>)}
        </RadioGroup>
      </FormControl>
    </div>
  );
}

export default FormRadioGroup;


// WEBPACK FOOTER //
// ./src/components/lib/Form/RadioGroup/FormRadioGroup.tsx